export default __webpack_public_path__ + "static/media/70.707fb785.jpg";